import {createTheme, responsiveFontSizes} from "@mui/material";
import {palette} from "./palette";
import {typography} from './typography'
import {formLabel} from './formLabel'

const defaultTheme = createTheme();
// defaultTheme.overrides.MuiGrid.root.max
let theme = {...palette(defaultTheme)}
theme = {...formLabel(theme)}
theme = {...typography(theme)}

export default responsiveFontSizes(theme)
